# WHERE PIPER AUDIO IS SERVED FROM — one definition.
#
# instruction_set.coffee built this URL inline at say() time, and it was the
# only place that knew it. The warm-up (card 6aaa14f67fc38cab6b35ae09) has to
# fetch the SAME url the say path will ask for a moment later, or the cache it
# fills is a cache nothing reads — so the host is a constant both import
# rather than a literal each spells for itself.
export AUDIO_CDN_BASE = 'https://d2l4gvz6xsdl0z.cloudfront.net/'
